const XTwitterIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path d='M6.19051 2.58359H2.24981L11.7226 16.0836H15.7498L6.19051 2.58359ZM3.91295 3.4388H5.7298L14.0785 15.2288H12.1856L3.91295 3.4388Z' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.19051 2.58359L15.7498 16.0836H11.7226L2.24981 2.58359H6.19051ZM1.96131 2.43359H6.26809L16.0398 16.2336H11.6446L1.96131 2.43359ZM12.1856 15.2288H14.0785L5.7298 3.4388H3.91295L12.1856 15.2288ZM4.20144 3.5888L12.2636 15.0788H13.7885L5.65222 3.5888H4.20144Z'
        />
        <path d='M7.64776 10.0836L8.24981 10.9137L8.22937 10.8894L3.56588 16.0836H2.24981L7.64776 10.0836Z' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.66029 9.84539L8.37123 10.8256L8.25744 10.9146L8.34098 10.9896L3.63279 16.2336H1.91309L7.66029 9.84539ZM8.22937 10.8894L8.24981 10.9137L7.64776 10.0836L2.24981 16.0836H3.56588L8.22937 10.8894Z'
        />
        <path d='M15.7498 2.58359L10.3313 8.58359L9.74981 7.78875L14.4587 2.58359H15.7498Z' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.0874 2.43359L10.3191 8.82093L9.55661 7.77871L14.3921 2.43359H16.0874ZM15.7498 2.58359H14.4587L9.74981 7.78875L10.3313 8.58359L15.7498 2.58359Z'
        />
      </svg>
    </span>
  );
};

export default XTwitterIcon;
